<template>
  <div class="search">
    <div
      class="search__stage"
    >
      <div class="search__wrapper">
        <button
          class="button button--neutral button--circle button--s"
          @click.prevent="$store.dispatch('search/close')"
        >
          <i class="icon icon-arrow-left" />
        </button>
        <div class="search__content">
          <div class="search__head">
            <div class="form-search">
              <span class="form-search__icon">
                <i class="icon icon-zoom" />
              </span>
              <input
                id="search-form"
                v-model="query"
                type="text"
                class="form-input u-br"
                placeholder="Search"
                value="aminid"
              >
            </div>
          </div>
          <div class="search__body">
            <div class="search__result">
              <div class="search__result__group">
                <h4>Search Result</h4>
                <InertiaLink
                  v-for="(result, index) in results"
                  :key="index"
                  :href="result.url"
                  class="search__result__item"
                  @click="recordRecent(result)"
                >
                  <span class="data">{{ result.title }}</span>
                  <span class="data data--muted">{{ result.type | titlecase }}</span>
                </InertiaLink>
              </div>
              <div class="search__result__group">
                <h4>Recently Searched</h4>
                <div
                  v-for="(entry, index) in recent"
                  :key="index"
                  class="search__result__item"
                >
                  <span class="data">{{ entry.title }}</span>
                  <span class="data data--muted">{{ entry.type | titlecase }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { mapGetters } from 'vuex'

export default {
  name: 'SearchForm',
  data: () => ({
    query: null,
  }),
  computed: {
    ...mapGetters({
      results: 'search/results',
      recent: 'search/recent',
    }),
  },
  watch: {
    query: debounce(function(value) {
      this.$store.dispatch('search/setQuery', value)
    }, 500),
  },
  created() {
    this.$store.dispatch('search/init')

    this.$nextTick(() => {
      document.getElementById('search-form').focus()
    })

    this.query = this.$store.getters['search/query']
  },
  mounted () {
    document.addEventListener('keydown', this.handleCloseModal)
  },
  destroyed () {
    document.removeEventListener('keydown', this.handleCloseModal)
  },
  methods: {
    handleCloseModal (e) {
      if (e.keyCode === 27) {
        this.$store.dispatch('search/close')
      }
    },
    recordRecent (result) {
      this.$store.dispatch('search/recordRecent', result)
      this.$store.dispatch('search/close')
    },
  },
}
</script>
